import { Directive } from '@angular/core';

@Directive({
  selector: '[comp-dialog-header-inner-title]',
})
export class DialogHeaderInnerTitleDirective {}

@Directive({
  selector: '[comp-dialog-header-inner-subtitle]',
})
export class DialogHeaderInnerSubtitleDirective {}

@Directive({
  selector: '[comp-dialog-header-inner-action-items]',
})
export class DialogHeaderActionItemsInnerDirective {}
